import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PaidFeatureUpgradeMode} from "../../paid-feature-upgrade.component";
import features from "./fetures.json";
import {GoogleAnalyticsService} from "../../../../../services/google-analytics/google-analytics.service";

interface Point {
  img: any;
  title?: string;
  desc?: string;
}

@Component({
    selector: 'db-pro-booster-upgrade',
    templateUrl: './pro-booster-features.component.html',
    styleUrls: ['./pro-booster-features.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UpgradeBoosterProComponent implements OnInit {

  @Input() mode: PaidFeatureUpgradeMode;
  @Output() onStepChange = new EventEmitter<'plans'>();
  public points: Point[] = features;

  constructor( private _googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit() {
  }

  public sendEvent(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Upgrade button click',
      eventLabel: 'Pro Level Upgrade Offer'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
